(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-search-form/assets/javascripts/casino-search-form.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-search-form/assets/javascripts/casino-search-form.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  Button = _svs$ui.ReactButton;
const _svs$ui$reactForm = svs.ui.reactForm,
  Input = _svs$ui$reactForm.Inputv2,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const _svs$components$casin = svs.components.casino_react.hooks,
  useSetSearchParams = _svs$components$casin.useSetSearchParams,
  useSearchParams = _svs$components$casin.useSearchParams;
const toggleQuickTransaction = svs.components.casino.shared.toggleQuickTransaction;
const DEBOUNCE_INTERVAL = 500;
let trackSearchDelayer;
const trackSearchString = str => {
  clearTimeout(trackSearchDelayer);
  if (str && str.length > 1) {
    trackSearchDelayer = setTimeout(() => {
      svs.components.analytics.trackSearch(str, 'Casino');
    }, 2000);
  }
};
const CasinoSearchForm = () => {
  const _useSearchParams = useSearchParams(),
    queryString = _useSearchParams.q;
  const _useState = useState(queryString),
    _useState2 = _slicedToArray(_useState, 2),
    searchInputValue = _useState2[0],
    setSearchInputValue = _useState2[1];
  const _useSetSearchParams = useSetSearchParams(),
    setQuery = _useSetSearchParams.setQuery,
    clearParams = _useSetSearchParams.clearParams;
  const debounceTimer = useRef(null);
  useEffect(() => {
    setSearchInputValue(queryString);
  }, [queryString]);
  const onInputChange = useCallback(e => {
    setSearchInputValue(e.target.value);
    if (e.target.value === '') {
      setQuery(e.target.value);
      return;
    }
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      trackSearchString(e.target.value);
      setQuery(e.target.value);
    }, DEBOUNCE_INTERVAL);
    return () => clearTimeout(debounceTimer.current);
  }, [setQuery]);
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  return React.createElement(Form, {
    className: "casino-search-form",
    isVertical: !isSmallDevice,
    onSubmit: e => {
      e.preventDefault();
    }
  }, searchInputValue && React.createElement(Button, {
    "aria-label": "Rensa s\xF6k",
    className: "casino-search-form__button-reset-search",
    onClick: () => {
      setSearchInputValue('');
      clearParams();
    }
  }, React.createElement(ReactIcon, {
    icon: "menu-left",
    size: "300"
  })), React.createElement(ControlGroup, {
    className: "casino-search-form__control-group",
    v2: true
  }, React.createElement(Input, {
    autoComplete: "off",
    label: "S\xF6k",
    onBlur: () => toggleQuickTransaction(false),
    onChange: onInputChange,
    onFocus: () => toggleQuickTransaction(true),
    suffix: React.createElement(Button, {
      "aria-label": "S\xF6k efter: ".concat(searchInputValue ? searchInputValue : 'casino spel'),
      className: "casino-search-form__search-icon-wrapper"
    }, React.createElement(ReactIcon, {
      color: "navy",
      icon: "search",
      size: "100"
    })),
    type: "text",
    value: searchInputValue
  })));
};
setGlobal('svs.components.casino_react.casinoSearchForm.CasinoSearchForm', CasinoSearchForm);

 })(window);